export { Config };
import { useConfig } from '../../hooks/useConfig/useConfig-client.js';
function Config(props) {
    const config = useConfig();
    config(props);
    return null;
}
